<div class="bg-white rounded-lg border border-gray-200 p-8">
  <h1 class="text-2xl font-bold text-[#3abfad] mb-1">3. Resultado evaluación</h1>
  <p class="text-gray-600 mb-6">Conoce la oferta que tenemos disponible para ti</p>

  <!-- Tarjeta aprobada -->
  <div class="bg-[#3abfad] text-white rounded-lg p-6 mb-8">
    <div class="text-center">
      <h2 class="text-2xl font-bold mb-2">¡Felicidades!</h2>
      <p class="text-xl mb-1">Tienes una tarjeta de crédito Unipay aprobada</p>
      <p class="text-2xl font-bold">con un cupo de $600.000</p>
    </div>
  </div>

  <!-- Costos asociados -->
  <div class="mb-8">
    <div class="flex items-center gap-2 mb-2">
      <span class="h-5 w-5 text-[#3abfad]">💰</span>
      <h3 class="text-lg font-medium text-gray-700">Costos asociados a la tarjeta</h3>
    </div>
    <p class="text-gray-600 mb-2">
      Comisión de Administración Mensual de su tarjeta es de <span class="font-semibold">0.12UF ($4.612)*</span>
    </p>
    <a href="#" class="text-[#3abfad] hover:underline flex items-center text-sm mb-1">
      Revisar condiciones del descuento
      <span class="ml-1 h-3 w-3">→</span>
    </a>
    <p class="text-xs text-gray-500 italic">*Este monto se encuentra redondeado según promoción</p>
  </div>

  <hr class="my-8" />

  <!-- Por qué contratar -->
  <div class="mb-6">
    <h3 class="text-base font-medium text-gray-700 mb-3">¿Por qué contratar Unipay?</h3>
    <ul class="space-y-4">
      <li class="flex items-start">
        <span class="mr-2 text-[#3abfad] font-bold">•</span>
        <p class="text-sm text-gray-600">
          Tu Unipay es una tarjeta de crédito para uso en Unimarc, Super 10 y Alvi, donde podrás acceder a
          ofertas exclusivas sobre el catálogo y descuentos sobre descuentos adicionales en promociones.
        </p>
      </li>
      <li class="flex items-start">
        <span class="mr-2 text-[#3abfad] font-bold">•</span>
        <p class="text-sm text-gray-600">
          <span class="font-medium">No necesitas una tarjeta física, solo necesitas tu huella</span> para pagar
          tus compras, sin embargo, puedes solicitarla en caso de requerirla.
        </p>
      </li>
      <li class="flex items-start">
        <span class="mr-2 text-[#3abfad] font-bold">•</span>
        <p class="text-sm text-gray-600">
          Además puedes optar a realizar giros de dinero, por medio de Avances en Efectivo y Super Avances, previo a
          una evaluación crediticia.
        </p>
      </li>
    </ul>
  </div>
</div> 